import {ActionTree} from 'vuex'
import axios, {AxiosError} from "axios";
import * as moment from 'moment';

export const actions: ActionTree<any, any> = {

    getTangoCatalog: ({state, getters, commit, dispatch}, force) => {

        if (force) commit('bustCache');

        // Pull from store if loaded and cache hasn't expired
        if (state.expires && moment().isBefore(state.expires)) {
            return state.brands;
        }
        commit('setLoading', true);

        return new Promise((resolve, reject) => {

            axios.get('/rewards/tango-card/catalog')

                .then((response) => {

                    commit('setBrands', response.data.catalog.brands);
                    commit('setLoading', false);
                    resolve(response);
                })
                .catch(error => {
                    commit('setLoading', false);
                    reject(error);
                });
        });
    },

    getTangoRewards: ({state, getters, commit, dispatch}) => {
        return new Promise((resolve, reject) => {

            axios.get('/rewards/tango-card')

                .then((response) => {
                    commit('setTangoCardRewards', response.data.rewards);
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },

    getPartners: ({state, getters, commit, dispatch}, force) => {

        return new Promise((resolve, reject) => {

            if (!force &&state.partnersExpire && moment().isBefore(state.partnersExpire)) {
                resolve(state.partners);
                return;
            }

            axios.get('/reward-integrations')

                .then((response) => {

                    commit('setPartners', response.data.data);
                    resolve(response);

                })
                .catch(error => {
                    console.log(error);
                    reject(error);
                });
        });
    },

    createPartnerSettings: ({state, getters, commit, dispatch}, settings) => {

        return new Promise((resolve, reject) => {

            if (!settings.id) delete (settings.id);

            axios.post('/reward-integrations', settings)

                .then((response) => {
                    commit('addPartner', response.data.data);
                    resolve(response.data.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },

    enablePartner: ({state, getters, commit, dispatch}, id: number) => {

        return new Promise((resolve, reject) => {

            axios.post('/reward-integrations/enabled/' + id)

                .then(({data}) => {
                    commit('enablePartner', id);
                    resolve(null);
                })
                .catch((error: AxiosError) => {
                    reject(error);
                });
        });
    },


    disablePartner: ({state, getters, commit, dispatch}, id: number) => {

        return new Promise((resolve, reject) => {

            axios.post('/reward-integrations/disabled/' + id)

                .then(({data}) => {
                    commit('disablePartner', id)
                    resolve(null);
                })
                .catch((error: AxiosError) => {
                    reject(error);
                });
        });
    },

    getPayPalRewards: ({state, getters, commit, dispatch}) => {

        commit('setPayPalRewardsLoading', true);

        return new Promise((resolve, reject) => {

            axios.get('/rewards/pay-pal')

                .then(({data}) => {
                    commit('setPayPalRewards', data.data);
                    commit('setPayPalRewardsLoading', false);
                    resolve(null);
                })
                .catch((error: AxiosError) => {
                    commit('setPayPalRewardsLoading', false);
                    reject(error);
                });
        });
    },

    getPayPalCurrencies: ({state, getters, commit, dispatch}) => {

        commit('setPayPalCurrenciesLoading', true);

        return new Promise((resolve, reject) => {

            axios.get('/rewards/pay-pal/currencies')

                .then(({data}) => {
                    commit('setPayPalCurrencies', data.data);
                    commit('setPayPalCurrenciesLoading', false);
                    resolve(null);
                })
                .catch((error: AxiosError) => {
                    commit('setPayPalCurrenciesLoading', false);
                    reject(error);
                });
        });
    },

    setPayPalNominations: ({state, getters, commit, dispatch}, data: any) => {

        return new Promise((resolve, reject) => {

            axios.post('/rewards/pay-pal', data)

                .then(({data}) => {
                    commit('setPayPalRewards', data.data);
                    resolve(null);
                })
                .catch((error: AxiosError) => {
                    reject(error);
                });
        });
    },

    setTangoCardNominations: ({state, getters, commit, dispatch}, data: any) => {
        return new Promise((resolve, reject) => {

            axios.post('/rewards/tango-card', data)

                .then((response) => {
                    commit('setTangoCardRewards', response.data.rewards);
                    resolve(response);
                })
                .catch((error: AxiosError) => {
                    reject(error);
                });
        });
    },

    removeReward: ({state, getters, commit, dispatch}, id: Number) => {
        return new Promise((resolve, reject) => {

            axios.delete('/rewards/' + id)

                .then((response) => {
                    commit('removeReward', id);
                    resolve(response);
                })
                .catch((error: AxiosError) => {
                    reject(error);
                });

        });
    }
};
